import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetPurchaseState, getPurchase as onGetPurchases } from "../../../store/purchase/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import { useRef } from "react";

const ReportPurchaseMaterial = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [purchaseDoc, setPurchaseDoc] = useState([]);
  const dispatch = useDispatch();

  const { purchases, isPurchaseCreated, isPurchaseSuccess, loading, error, companies, companyLoading } = useSelector((state) => ({
    purchases: state.Purchase.purchases,
    isPurchaseCreated: state.Purchase.isPurchaseCreated,
    isPurchaseSuccess: state.Purchase.isPurchaseSuccess,
    loading: state.Purchase.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Purchase.error,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setPurchaseList(purchases);
  // }, [purchases]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      let purchaseDetailList = [];
      purchases.forEach((purchase) => {
        purchase.purchase_detail.forEach((purchaseDetail) => {
          const data = {
            id: purchaseDetail.id,
            code: purchase.code,
            transactionat: purchase.transactionat,
            dueat: purchase.dueat,
            name: purchaseDetail.name,
            amount: purchaseDetail.amount,
            amount_total: purchaseDetail.amount_total,
            cvl_account: purchaseDetail.cvl_account,
            quantity: purchaseDetail.quantity,
            purchase_status: purchase.purchase_status,
            hasPaid: purchase.hasPaid,
          };
          purchaseDetailList.push(data);
        });
      });

      purchaseDetailList.sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat));

      setPurchaseList(purchaseDetailList.map((el) => ({ ...el, isChecked: false })));
    }
  }, [purchases]);

  useEffect(() => {
    if (!isSearch) {
      //   dispatch(onGetPurchases({ id: "1", ok: "ok" }, "/purchase-daily"));
      dispatch(onGetPurchases({ typeId: 1 }));
    }
    setIsSearch(true);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (obj.data && obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role) {
      setCompanyName({
        label: obj?.data?.user.user_company.name,
        value: obj?.data?.user.user_company.id,
      });
      setRoles(obj?.data?.user?.user_position?.position_role.method);
    } else setRoles(null);

    if (obj?.data) setUserType(obj?.data?.userType);
  }, [dispatch, purchases, isSearch]);

  useEffect(() => {
    return () => {
      dispatch(resetPurchaseState());
    };
  }, []);

  function handleCompany(e) {
    if (e.length > 2) {
      const param = { title: e, status: 2 };
      dispatch(getCompany(param));
    }
    return false;
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    setPurchase(purchases);
  }, [purchases]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      setPurchase(purchases);
    }
  }, [purchases]);

  // useEffect(() => {
  //   setPurchaseList(purchases);
  // }, [purchases]);

  // useEffect(() => {
  //   if (!isEmpty(purchases)) setPurchaseList(purchases);
  // }, [purchases]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "amount_total",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "transactionat" || doc.id === "dueat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "amount" || doc.id === "amount_total" || doc.id === "quantity") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "purchase_status") {
                doc.data.push(`${value && value.name} - ${data.hasPaid ? "PAID" : "UNPAID"}`);
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPurchaseDoc(dataDoc);
  }, [purchaseList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPurchaseList(updatedData);
                }} />
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "code",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return <span className="fw-semibold text-dark">{data.code}</span>;
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return <span>{data.name}</span>;
        },
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.transactionat);
        },
      },
      {
        Header: "Jatuh Tempo",
        accessor: "dueat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.dueat);
        },
      },
      {
        Header: "Jumlah",
        accessor: "quantity",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.quantity === null ? 0 : data.row.original.quantity)}</span>;
        },
      },
      {
        Header: "Harga",
        accessor: "amount",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.amount === null ? 0 : data.row.original.amount)}</span>;
        },
      },
      {
        Header: "Total",
        accessor: "amount_total",
        filterable: true,
        Cell: (data) => {
          return <span className="fw-semibold">{currencyFormat(data.row.original.amount_total === null ? 0 : data.row.original.amount_total)}</span>;
        },
      },
      // {
      //   Header: "Down Payment",
      //   accessor: "down_payment",
      //   filterable: true,
      //   Cell: (data) => {
      //     return <span>{currencyFormat(data.row.original.down_payment === null ? 0 : data.row.original.down_payment)}</span>;
      //   },
      // },
      {
        Header: "Status",
        accessor: "purchase_status.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          let stat;
          let statName = data.purchase_status && data.purchase_status.name;
          switch (statName) {
            case "DRAFT":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            case "CONFIRMED":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "PROCESSED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "RECEIVED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "COMPLETED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
              break;
          }

          return (
            <div className="hstack gap-2">
              {stat}
              {data.hasPaid ? <span className="badge text-uppercase badge-soft-info">Paid</span> : <span className="badge text-uppercase badge-soft-warning">Unpaid</span>}
            </div>
          );
        },
      },
    ],
    [purchaseList, isCheckAll]
  );


  const [filterDate, setFilterDate] = useState(null);

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handlePurchaseStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetPurchases(param));
  }

  document.title = "Laporan Pembelian Material | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <Container fluid>
        <BreadCrumb title="Laporan Pembelian Material" pageTitle="Pembelian" />
        <Row>
          <Col lg={12}>
            <Card id="purchaseList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Laporan Pembelian Material &nbsp;
                    {isLoading ? (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    ) : (
                      ""
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={purchaseDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}/>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}/>
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handlePurchaseStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr className={""} key={index} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      {rows.length} Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}>
                          
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReportPurchaseMaterial;
